export default state => state.savedItems.boards.boardTitleText;
